import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://qcxnigwacytqbxzvkvje.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFjeG5pZ3dhY3l0cWJ4enZrdmplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODM0NDI5NzcsImV4cCI6MjA5OTAxODk3N30.xJu5nJe56XQqrp5iwe3S89wPrmWmw1TvbNOG2uCvSsM'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})